export default __webpack_public_path__ + "static/media/mango.e214a476.svg";